import { PdToast } from "./pd-toast/PdToast.js";
//#region src/pd-toast/pd-toast.ts
var tag = "pd-toast";
if (!customElements.get(tag)) customElements.define(tag, PdToast);
//#endregion
export { PdToast };
